export interface EntityAttachment {
  id: string;
  url: string;
  fileName: string;
  mimeType: string;
  label?: string | null;
  createdAt: string;
}

export const MAX_ENTITY_ATTACHMENTS = 10;

export function isPdfAttachment(mimeType: string): boolean {
  return mimeType === "application/pdf" || mimeType.endsWith("/pdf");
}

export function isImageAttachment(mimeType: string): boolean {
  return mimeType.startsWith("image/");
}
